
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import useValidate from '@vuelidate/core'
import mainDescriptor from './MetawebDescriptor.json'
import Dialog from 'primevue/dialog'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import BusinessModelTab from './businessModel/MetawebBusinessModel.vue'
import MetawebPhysicalModel from './physicalModel/MetawebPhysicalModel.vue'
import MetawebInvalidRelationshipsDialog from './invalidRelationshipsDialog/MetawebInvalidRelationshipsDialog.vue'

const { observe, generate, applyPatch } = require('fast-json-patch')

export default defineComponent({
    name: 'metaweb',
    components: { BusinessModelTab, MetawebPhysicalModel, TabView, TabPanel, Dialog, MetawebInvalidRelationshipsDialog },
    props: { visible: { type: Boolean }, propMeta: { type: Object }, businessModel: { type: Object } },
    emits: ['closeMetaweb', 'modelGenerated'],
    data() {
        return {
            v$: useValidate() as any,
            mainDescriptor,
            meta: null as any,
            observer: null as any,
            metaUpdated: false,
            invalidRelationshipsDialogVisible: false,
            incorrectRelationships: [] as any[],
            loading: false
        }
    },
    computed: {},
    watch: {
        propMeta() {
            this.loadMeta()
        }
    },
    created() {
        this.loadMeta()
    },
    methods: {
        loadMeta() {
            this.meta = this.propMeta

            if (this.meta) {
                this.observer = observe(this.meta)
            }
        },
        setLoading(loading: boolean) {
            this.loading = loading
        },
        async metadataSave() {
            await this.checkRelationships(true)
        },
        onMetaUpdated() {
            this.checkRelationships(false)
        },
        async checkRelationships(generateModel: boolean) {
            this.loading = true
            const postData = { data: { name: this.businessModel?.name, id: this.businessModel?.id }, diff: generate(this.observer) }
            await this.$http
                .post(process.env.VUE_APP_META_API_URL + `/1.0/metaWeb/checkRelationships`, postData)
                .then(async (response: AxiosResponse<any>) => {
                    this.observer = applyPatch(this.observer, response.data).newDocument
                    this.observer = observe(this.meta)
                    this.metaUpdated = !this.metaUpdated
                    if (generateModel)
                        if (response.data.incorrectRelationships.length === 0) {
                            await this.generateModel()
                        } else {
                            this.invalidRelationshipsDialogVisible = true
                            this.incorrectRelationships = response.data.incorrectRelationships
                        }
                })
                .catch(() => {})
            this.loading = false
        },
        async generateModel() {
            const postData = { data: { name: this.businessModel?.name, id: this.businessModel?.id }, diff: generate(this.observer) }
            await this.$http
                .post(process.env.VUE_APP_META_API_URL + `/1.0/metaWeb/generateModel`, postData)
                .then(() => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.createTitle'),
                        msg: this.$t('common.toast.success')
                    })
                    this.$emit('modelGenerated')
                })
                .catch(() => {})
                .finally(() => (this.invalidRelationshipsDialogVisible = false))
        },
        closeMetawebConfirm() {
            this.$confirm.require({
                header: this.$t('metaweb.exitFromMeta'),
                accept: () => {
                    this.$emit('closeMetaweb')
                    this.meta = null
                    this.observer = null
                    this.incorrectRelationships = []
                }
            })
        }
    }
})
